import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-order-selection',
    templateUrl: './order-selection.component.html',
    styleUrls: ['./order-selection.component.scss'],
    standalone: false
})
export class OrderSelectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
